<template>
      <v-radio-group v-model="paymentOption" :mandatory="false">
      <div
        style="min-height: 77px;"
        class="radio-option-paypal"
        @click="paymentOption = option.id"
        :class="paymentOption == option.id ? 'option-active' : 'option-deactive'"
      >
      <v-layout class="radio-option__info">
        <v-flex>
          <v-layout row>
        <v-icon class="payment-option_icon">credit_card</v-icon>
        <div class="radio-option__info-text">
          <label :for="option.id">{{ option.label }}</label>
        </div>
          </v-layout>
        </v-flex>
        <v-flex shrink>
          <v-radio style="margin-right: 6px;" color="primary" :id="option.id" :value="option.id"></v-radio>
        </v-flex>
      </v-layout>

      <v-card flat v-if="paymentOption === 'PPE'">
        <v-container align-center class="paypal-container">
          <template>
            <paypal-plus
              v-if="paypalReady"
              ref="ppplus"
              :mode="checkEnviroment()"
              :approvalUrl="paypalToken"
              :firstName="userProps.name.split(' ').slice(0, -1).join(' ')"
              :lastName="userProps.name.split(' ').slice(-1).join(' ')"
              country="BR"
              :taxId="userProps.document"
              :email="userProps.email"
              :phone="userProps.phone"
              @checkout="onContinue"
              @error="onError"
            />
            <!-- <v-btn v-if="paypalReady" @click="handleCheckout">Continue</v-btn> -->
            <v-btn
              v-if="paypalReady"
              block
              round
              depressed
              class="normal-text"
              :class="{ 'btn-disabled': !canPurchase }"
              :color="canPurchase ? 'primary' : 'info'"
              dark
              @click="handleCheckout"
            >Confirmar</v-btn>
            <v-layout v-if="!paypalReady && canPurchase" justify-center>
              <span class="text-xs-center pt-3 pb-3">Por favor Aguarde...</span>
            </v-layout>
            <v-layout v-if="!paypalReady && !canPurchase" justify-center>
              <span class="text-xs-center pt-3 pb-3">Preencha seus dados pessoais</span>
            </v-layout>
          </template>
        </v-container>
      </v-card>
      </div>
      </v-radio-group>
</template>

<script>
import { mapGetters } from 'vuex';
import PaypalPlus from 'paypalplus-for-vue'

export default {
  components: {
    PaypalPlus
  },
  data() {
    return {
      paypalReady: false,
      componentKey: 0,
      option: {
        id: 'PPE',
        label: 'Cartão de Crédito',
        info: '',
      },
      loads: null,
      specialCode: null,
    };
  },
  watch: {
    paymentOption () {
      if (this.paymentOption === 'PPE' && !this.paypalReady && this.canPurchase ) {
      this.requestPaypalUrl()
      }
    },
    canPurchase () {
      if (this.canPurchase && !this.paypalReady && this.paymentOption === 'PPE') {
        this.requestPaypalUrl()
      }
    }
  },
  methods: {
    checkEnviroment () {
      if (process.env.VUE_APP_ENV === 'development') return 'sandbox'
      else return 'live'
    },
    validateCNPJ(cnpj) {
      if (cnpj && cnpj.length) {
      cnpj = cnpj.replace(/[^\d]+/g,'');

      if(cnpj === '') return false;

      if (cnpj.length !== 14)
          return false;

      // Elimina CNPJs invalidos conhecidos
      if (cnpj === "00000000000000" ||
          cnpj === "11111111111111" ||
          cnpj === "22222222222222" ||
          cnpj === "33333333333333" ||
          cnpj === "44444444444444" ||
          cnpj === "55555555555555" ||
          cnpj === "66666666666666" ||
          cnpj === "77777777777777" ||
          cnpj === "88888888888888" ||
          cnpj === "99999999999999")
          return false;

      // Valida DVs
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0,tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (parseInt(resultado) !== parseInt(digitos.charAt(0)))
          return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0,tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (parseInt(resultado) !== parseInt(digitos.charAt(1)))
            return false

      return true
    } else {
      return false
    }
    },
    validateCPF(cpf) {
      cpf = cpf.replace(/-|\./g, '');
      let numeros;
      let digitos;
      let soma;
      let i;
      let resultado;
      let digitosIguais;
      digitosIguais = 1;
      if (cpf.length < 11) {
        return false;
      }
      for (i = 0; i < cpf.length - 1; i++) {
        if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
          digitosIguais = 0;
          break;
        }
      }
      if (!digitosIguais) {
        numeros = cpf.substring(0, 9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--) {
          soma += numeros.charAt(10 - i) * i;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(0))) {
          return false;
        }
        numeros = cpf.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--) {
          soma += numeros.charAt(11 - i) * i;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(1))) {
          return false;
        }
        return true;
      }
      return false;
    },
    async requestPaypalUrl () {
      await this.$store.dispatch('getPaypalOrderId').then(() => {
        this.paypalReady = true
      });
    },
    onContinue(data) {
      this.$store.dispatch('addLoading');
        let payerId = data.payer.payer_info.payer_id
        const orderID = this.$route.name === 'commissioner' ? this.orderPdvData.codigo_pedido : this.$store.getters.body.codigo_pedido;
        this.$axios.post('/orders/charge/digital/paypal/capture', { payer_id: payerId, order_id: orderID, event_id: this.$store.getters.eventID } 
        ).then((res) => {
          if(res.data.status === 'paid' || res.data.status === 'analysis') {
            const postOrder = {
            ...this.$store.getters.postOrder,
            phone: this.userProps.phone,
            email: this.userProps.email,
            status: res.data.status === 'paid' ? 'Aprovado' : 'Em Análise',
            card: ``,
            instalments: ``,
            hash_pedido: this.$store.getters.body.hash_pedido,
            payment: this.$store.state.paymentOption,
            organizador: res.data.orderData.nome_organizador,
            cpf_organizador: res.data.orderData.org_cpf,
            cnpj_organizador: res.data.orderData.org_cnpj,
            mensagem: res.data.orderData.mensagem_conclusao_pedido
          };

          this.$store.dispatch('setPostOrder', postOrder);
          this.$store.dispatch('setBody', {
            ...this.$store.getters.body,
            expiration: 0,
          });
          if (res.data.status === 'paid') this.$store.commit('SET_TICKET_URL', res.data.orderData.ticketsUrl);
          console.log('setPurchaseStarted - onContinue - false')
          this.$store.dispatch('setPurchaseStarted', false);
          this.$store.dispatch('nextStep')
          this.$store.dispatch('saveBuyerData')
          this.$store.dispatch('subtractLoading');
          }

          if(res.data.status === 'refused') {
            this.$store.dispatch('openErrorDialog', 'Transação recusada');
            this.$store.dispatch('subtractLoading');
          }
         
        })
      
    },
    onError(data) {
        let error = data.error;
        this.$store.dispatch('subtractLoading');
        switch(error) {
            case 'TRY_ANOTHER_CARD':
                alert('Por favor tente outro cartão para executar essa transação')
                this.componentKey += 1
        }
    },
    handleCheckout() {
        localStorage.setItem('iframePurcheased', true);
        this.$refs.ppplus.pppContinue();
    },
    updateLoads(data) {
      data = data.value;
      this.body = {
        ...this.body,
        parcelas: data.instalments,
      };
      this.$store.dispatch('setInstalmentAmount', data.instalments);
      this.$store.dispatch('setInterestAmount', data.interestAmount);
      this.$store.dispatch('setTotalAmount', data.total);
    },
  },
  computed: {
    ...mapGetters({
      userProps: 'userProps', 
      paypalToken: 'paypalToken',
      orderPdvData: 'orderPdvData'
    }),
    canPurchase() {
      let hasUserProps = false;

      if (this.userProps && this.userProps.name && (this.userProps.email === this.userProps.emailConfirmation) && this.userProps.phone && this.userProps.phone.length > 10 && this.userProps.document) {
        if (this.userProps.selectedDocument === 'cpf' && this.validateCPF(this.userProps.document)) hasUserProps = true
        if (this.userProps.selectedDocument === 'cnpj' && this.validateCNPJ(this.userProps.document)) hasUserProps = true
        if (this.userProps.selectedDocument === 'foreigner' && this.userProps.document) hasUserProps = true
      }

      return hasUserProps;
    },
    body: {
      get() {
        return this.$store.getters.body;
      },
      set(value) {
        this.$store.dispatch('setBody', value);
      },
    },
    paymentOption: {
      get() {
        return this.$store.getters.paymentOption;
      },
      set(value) {
        this.$store.dispatch('setPaymentOption', value);
      },
    },
  },
  mounted () {
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/payment/paymentPaypal.styl'
@import '~@/assets/payment/paymentBillet.styl'
</style>

<style>
.custom-text .v-label {
  top: 18px !important;
}
</style>
